import React, { useEffect, useState } from 'react';
import axios from 'axios';
import '../../common/css/waitRequest.css';
import SaveModal from '../modal/saveModal';
import Cookies from 'js-cookie';

function RequestPage() {
    const [modalAction, setModalAction] = useState(null);
    const [modalContent, setModalContent] = useState(null);
    const [saveStatus, setSaveStatus] = useState(true);
    const [isCheck, setIsCheck] = useState(true);
    const [sort, setSort] = useState(null);
    const [airPnrSeq, setAirPnrSeq] = useState(null);
    const [regAgentID, setRegAgentID] = useState('');
    const [regAgentName, setRegAgentName] = useState('');
    const [regAgentPhone, setRegAgentPhone] = useState('');
    const [pnr, setPnr] = useState(null);
    const [etc, setEtc] = useState(null);
    const [agnetGubun, setAgnetGubun] = useState(null);

    // 서버통신
    useEffect(() => {
        const axiosData = async () => {
            try {
                const hostname = window.location.hostname;
                let isLocal = null;
                if (hostname === 'wpal.philippineair.co.kr') {
            isLocal = true;
        } else {
            isLocal = false;
        }

                const response = await axios.get(
                    `${
                        isLocal
                            ? process.env.REACT_APP_PRODUCTION_API_URL
                            : process.env.REACT_APP_LOCAL_API_URL
                    }/wpal/board/standby/info`,
                    {
                        withCredentials: true,
                    },
                );
                setAirPnrSeq(response.data.pnrSeq);
                setSort(response.data.sort);
                setRegAgentName(response.data.userName);
                setRegAgentPhone(response.data.userPhone);
                setRegAgentID(response.data.userId);
                setAgnetGubun(response.data.agentGubun);
            } catch (error) {
                setModalContent(error?.response?.data?.message);
                setModalAction(() => () => (window.location.href = '/login'));
                setSaveStatus(false);
            }
        };
        if (Cookies.get('isLogin')) {
            axiosData();
        } else {
            setModalContent('로그인 후 이용 가능한 서비스 입니다.');
            setModalAction(() => () => (window.location.href = '/login'));
            setSaveStatus(false);
        }
    });

    const saveStandbyData = async () => {
        try {
            if (pnr == null) {
                setModalContent('항공사 예약번호를 입력해주세요.');
                setModalAction(() => () => setSaveStatus(true));
                setSaveStatus(false);
                return;
            }
            const data = {
                sort: sort >= 6 ? 1 : sort + 1,
                airPnrSeq: airPnrSeq + 1,
                regAgentID: regAgentID,
                regAgentName: regAgentName,
                regAgentPhone: regAgentPhone,
                pnr: pnr,
                etc: etc,
                chkMsgSend: isCheck ? 'Y' : 'N',
                agnetGubun,
            };

            const hostname = window.location.hostname;
            let isLocal = null;
            if (hostname === 'localhost' || hostname === 'twpal.philippineair.co.kr') {
                isLocal = false;
            } else {
                isLocal = true;
            }

            const response = await axios.post(
                `${
                    isLocal
                            ? process.env.REACT_APP_PRODUCTION_API_URL
                            : process.env.REACT_APP_LOCAL_API_URL
                }/wpal/board/standby/request`,
                data,
                {
                    withCredentials: true,
                },
            );

            if (response.data === 1) {
                window.location.href = '/service/standbyList';
            }
        } catch (error) {
            setModalContent(error?.response?.data?.message);
            setModalAction(() => () => (window.location.href = '/login'));
            setSaveStatus(false);
        }
    };
    return (
        <div id='contents' className='contents'>
            <div class='subp_h_wrap'>
                <div class='subp_h_list subp_h_home'>
                    <div>서비스요청</div>
                    <div>대기 전문 요청</div>
                    <div>요청하기</div>
                </div>
            </div>
            <div className='page_hgroup'>
                <h2 className='title'>대기 전문 요청</h2>
            </div>
            <div className='table_wrap mb40'>
                <table
                    className='table_style4 bdt mb70'
                    cellPadding='0'
                    cellSpacing='0'
                    id='airCertInfoTbl'
                >
                    <colgroup>
                        <col style={{ width: '190px' }} />
                    </colgroup>
                    <tbody>
                        <tr>
                            <th>
                                <p className='essential'>담당자</p>
                            </th>
                            <td colSpan='3'>{regAgentName}</td>
                        </tr>
                        <tr>
                            <th>
                                <p className='essential'>휴대폰 번호</p>
                            </th>
                            <td colSpan='3'>
                                {regAgentPhone}
                                <label name='agreeSendSNS'>
                                    <input
                                        type='checkbox'
                                        name='agreeSendSNS'
                                        id='agreeSendSNS'
                                        className='agreeSendSNSInput'
                                        checked={isCheck}
                                        onClick={() => setIsCheck(!isCheck)}
                                    />
                                    답변등록 시 SMS 전송
                                </label>
                                <a className='editPhoneNum' href='/mypage'>
                                    (&nbsp;&nbsp;<i class='fa-solid fa-mobile-screen-button'></i>
                                    &nbsp;&nbsp;담당자 휴대폰번호 수정&nbsp;&nbsp;)
                                </a>
                            </td>
                        </tr>
                        <tr>
                            <th>
                                <p className='essential'>항공사 예약번호</p>
                            </th>
                            <td colSpan='3'>
                                <input
                                    type='text'
                                    name='pnrData'
                                    id='pnrData'
                                    className='pnrData'
                                    maxLength='50'
                                    placeholder='예약번호'
                                    value={pnr}
                                    onChange={(e) =>
                                        setPnr(e.target.value.replace(/[\u3131-\u318F\uAC00-\uD7A3]/g, '').toUpperCase())
                                    }                            
                                />
                            </td>
                        </tr>
                        <tr>
                            <th>
                                <p>&nbsp;&nbsp;&nbsp;&nbsp;비고</p>
                            </th>
                            <td colSpan='3'>
                                <textarea
                                    type='text'
                                    id='remark'
                                    className='remarkInput'
                                    placeholder='요청 사유, 국내/국제 이원구간 연결편 등'
                                    style={{ display: 'block' }}
                                    value={etc}
                                    onChange={(e) => setEtc(e.target.value)}
                                />
                            </td>
                        </tr>
                    </tbody>
                    <p className='pointText'>
                        * 대기 전문 외 요청은 필리핀항공 대표번호 1544-1717로 유선 문의
                        부탁드립니다.
                    </p>
                </table>
            </div>
            <div className='btn_area'>
                <input
                    type='button'
                    id='sendRequest'
                    value='대기 전문 요청하기'
                    className='btn46 blue'
                    style={{ width: '260px' }}
                    onClick={() => {
                        saveStandbyData();
                    }}
                />
            </div>
            <div class='title_wrap mt70' style={{ justifyContent: 'flex-start' }}>
                <h4>유의 사항</h4>
            </div>
            <table class='table_style3 bdt' cellpadding='0' cellspacing='0' id='privateInfoTbl'>
                <colgroup>
                    <col style={{ width: '100%' }} />
                </colgroup>
                <tbody>
                    <tr>
                        {/*prettier-ignore */}
                        <td className='infoTable' style={{padding:'10px'}}>
                            <strong>1. 대기 전문 요청이 불가능한 경우</strong><br />
                            <span class="ml10">1) 중복예약(DUPE/SLD) - 동일대리점 또는 타 대리점 중복예약 포함</span><br />
                            <span class="ml10">2) 요금 조건에 대기 예약 불가로 공지된 경우</span><br />
                            <span class="ml10">3) 운임 규정상 E/T/U/O 는 대기 불가</span><br />
                            <strong>2. 대기 전문 요청은 확약을 보장하지 않습니다.</strong><br />
                            <strong>3. 실시간 확인이 아니며, 근무시간 기준 1일 이내 처리됩니다.</strong><br />
                            <strong>4. 대기 전문 요청이 접수된 예약은 '확인하기' 메뉴를 통해 확인한 후, CRS에서 최종 확인해주시기 바랍니다.</strong><br />
                        </td>
                    </tr>
                </tbody>
            </table>
            <div class='title_wrap mt70' style={{ justifyContent: 'flex-start' }}>
                <h3>한-비 구간 SC 발생 시</h3>
            </div>
            <table class='table_style3 bdt' cellpadding='0' cellspacing='0' id='privateInfoTbl'>
                <colgroup>
                    <col style={{ width: '100%' }} />
                </colgroup>
                <tbody>
                    <tr>
                        {/*prettier-ignore */}
                        <td className='infoTable' style={{padding:'10px'}}>
                            SC 발생으로 동일 BCC 대기 요청 시, 기존 Class가 T나 E인 경우, Segment를 유지한 상태에서 새로운 여정은 K Class 또는 AVAIL 중 가장 낮은 Class로 잡고 요청 글을<br />
                            남겨 주시기 바랍니다. (단, 좌석 상황에 따라 확약이 불가할 수 있습니다.)
                            <br /><br />
                            <p className='red' id='point'>
                                [한-비 제외 구간 SC 발생 시, Married Segment로 인한 대기 예약 방법]
                            </p>
                            SC 발생으로 기존 PNR 내 변경 작업을 진행할 경우, Married Segment 시스템 규정에 따라 기존 PNR 내 좌석 조회 시 실제 좌석 상황과 상이하게 조회될 수 있습니다.<br />
                            이 경우, 변경하실 여정으로 새로운 PNR에 작업한 뒤 대기 요청을 님겨주시기 바랍니다. 신규 PNR에서 좌석이 확약된 후에는 반드시 기존 PNR의 여정을 정리해주시기 바랍니다.
                        </td>
                    </tr>
                </tbody>
            </table>
            <SaveModal content={modalContent} SaveBtn={saveStatus} onClose={modalAction} />
        </div>
    );
}

export default RequestPage;
